export default "__VITE_ASSET__xpuhyGkI__"